
import React from 'react';
import Home from './pages/home';
import MobilePopup from './components/MobilePopup';

function App() {
  return (
    <div className="App">
      <MobilePopup />
      <Home />
    </div>
  );
}

export default App;